import { createRouter, createWebHistory } from 'vue-router';
import AgendaPage from '../Views/AgendaPage.vue';
import NuovaPrenotazionePage from '../Views/NuovaPrenotazionePage.vue';
import DettaglioPrenotazionePage from '../Views/DettaglioPrenotazionePage.vue';
import OggiPage from '../Views/OggiPage.vue';
import DetailsHomePage from '../Views/DetailsHomePage.vue';
import PrenotazioniInfoPage from '../Views/PrenotazioniInfoPage.vue';
import CorsePage from '../Views/CorsePage.vue';
import CorseFuturePage from '../Views/CorseFuturePage.vue';
import CorsePassatePage from '../Views/CorsePassatePage.vue';
import AddCarPage from '../Views/AddCarPage.vue';
import CustomerPage from '../Views/CustomerPage.vue';
import CustomerAliveDetailPage from '../Views/CustomerAliveDetailPage.vue';
import LoginPage from '../Views/LoginPage.vue';
import TariffePage from '../Views/TariffePage.vue';
import ErrorPage from '../Views/ErrorPage.vue';
import AddCustomerEmployeePage from '../Views/AddCustomerEmployeePage.vue';
import ProfilePage from '../Views/ProfilePage.vue'
import ResetPassword from '../Views/ResetPasswordPage.vue';
import LavoriAggiuntiviPage from '@/Views/LavoriAggiuntiviPage.vue';
import ModificaDataPage from '@/Views/ModificaDataPage.vue';
import JourneyPage from '@/Views/JourneyPage.vue';
import JourneyCalendarPage from '@/Views/JourneyCalendarPage.vue';
import DetailsJourneyPage from '@/Views/DetailsJourneyPage.vue';
import { isLoggedStore } from '@/store/logged';
import EstimatePageVue from '@/Views/EstimatePage.vue';
const routes = [

  {
    path: '/',
    name: 'Home',
    // Le corse di oggi.
    component: OggiPage,
  },
  {
    path: '/booking_attivo/:id',
    name: 'DetailsHome',
    component: DetailsHomePage,
  },
  {
    path: '/prenotazioni-info',
    name: 'PrenotazioniInfo',
    component: PrenotazioniInfoPage,
  },
  {
    path: '/corse',
    name: 'Corse',
    component: CorsePage,
  },
  {
    path: '/tasks/:id',
    name: 'LavoriAggiuntivi',
    component: LavoriAggiuntiviPage,
  },
  {
    path: '/update-date/:id',
    name: 'ModificaDataPage',
    component: ModificaDataPage,
  },
  {
    path: '/corse/corse_passate',
    name: 'CorsePassate',
    component: CorsePassatePage,
  },
  {
    path: '/corse/corse_future',
    name: 'CorseFuture',
    component: CorseFuturePage,
  },
  {
    path: '/addcustomer_employee',
    name: 'AddCustomerEmployee',
    component: AddCustomerEmployeePage,
  },
  {
    path: '/customer',
    name: 'Customer',
    component: CustomerPage,
  },
  {
    path: '/add-car/:id',
    name: 'AddCarPage',
    component: AddCarPage,
  },
  {
    path: '/details/customerAlive/:id',
    name: 'CustomerAliveDetail',
    component: CustomerAliveDetailPage,
  },
  {
    path: '/estimate/',
    name: 'EstimatePageVue',
    component: EstimatePageVue,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfilePage,
  },
  {
    path: '/tariffe',
    name: 'Tariffe',
    component: TariffePage,
  },
  {
    path: '/journey/:date',
    name: 'JourneyPage',
    component: JourneyPage,
    props: true,
  },
  {
    // AGENDA: prenotazioni e spostamenti interni insieme, due viste.
    path: '/agenda',
    name: 'AgendaPage',
    component: AgendaPage,
  },
  {
    // Ingresso unico alla creazione: la scelta del servizio dipende dalle
    // abilitazioni del partner. Accetta ?servizio= per saltare il primo passo.
    path: '/prenotazione/nuova',
    name: 'NuovaPrenotazione',
    component: NuovaPrenotazionePage,
  },
  {
    // Dettaglio di una prenotazione, raggiunto dalle righe dell'Agenda.
    path: '/agenda/prenotazione/:id',
    name: 'DettaglioPrenotazione',
    component: DettaglioPrenotazionePage,
  },
  {
    path: '/calendar',
    name: 'JourneyCalendarPage',
    component: JourneyCalendarPage,
  },
  {
    path: '/detail-journey/:date/:id',
    name: 'DetailsJourneyPage',
    component: DetailsJourneyPage,
    props: true,
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
  },
  {
    path: '/error',
    name: 'Error',
    component: ErrorPage,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const store = isLoggedStore();
  if (
    // make sure the user is authenticated
   store.isLogged == false &&
    // ❗️ Avoid an infinite redirect
    ( to.name !=='Login')

  ) {
    if(to.name !=='ResetPassword')

    {
    // redirect the user to the login page
    return { name: 'Login' };}
  }
  

  if (
    to.path == '/login' || to.name== '/reset-password'
  ) {
    store.viewMenu = false;
  } else {
    store.viewMenu = true;
  }


});

export default router;
